import { Injectable } from "@angular/core";
import { DataService } from "projects/Autofacets-Core/src/app/services/data.service";
import { Urls } from "projects/Autofacets-Core/src/app/utils/urls";
import { GenericResponse } from "../business-entities/generic-response";

@Injectable({
  providedIn: 'root'
})

export class WhatsAppLogDataService {

  constructor(private dataProvider: DataService) {
  }

  SendMessage(viewmodel: any): Promise<any> {
    return this.dataProvider.Post<GenericResponse<any>>(Urls.SendWhatsAppMessage, viewmodel).toPromise();
  }

  GetMessages(appointmentId: number): Promise<any> {
    const param = { AppointmentId: appointmentId };
    return this.dataProvider.Post<GenericResponse<any>>(Urls.GetWhatsAppMessages, param).toPromise();
  }

  GetUnrepliedWhatsAppMessages(): Promise<any> {
    return this.dataProvider.GetAll<GenericResponse<any>>(Urls.GetUnrepliedWhatsAppMessages).toPromise();
  }
}
